(function () {
  const initBenefitsAnimation = (section) => {
    if (!section.querySelector(".benefit")) return;
    section.classList.remove("benefits-section--animated");
    const enableHeaderAnimation = section.querySelector(
      "[data-enable-header-animation]"
    );
    const animate = () => {
      section.classList.add("benefits-section--animated");
      if (!enableHeaderAnimation) return;
      section.classList.add("anim-active");
    };
    const rect = section.getBoundingClientRect();
    if (rect.top <= window.innerHeight && rect.bottom >= 0) {
      animate();
    } else {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              animate();
              observer.unobserve(entry.target);
            }
          });
        },
        {
          threshold: 0,
          rootMargin: "0px 0px -35% 0px",
        }
      );
      observer.observe(section);
    }
  };
  const initSection = (section) => {
    if (!section || !section.classList.contains("benefits-section")) return;
    initBenefitsAnimation(section);
  };
  initSection(document.currentScript.parentElement);
  document.addEventListener("shopify:section:load", (e) => {
    initSection(e.target);
  });
  document.addEventListener("shopify:section:select", (e) => {
    initSection(e.target);
  });
})();
